import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { PatternDots, PatternLines, Defs } from '@nivo/core';
import { Empty } from "antd";

const CumulativeRecoveryWaterfallChart = ({ data }) => {
    // Prepare the data for the waterfall format
    console.log(data);
    if (!data.some(item => item.worst < 0)) {
        return <Empty description="No Items With Negative Drawdowns in Window" />;
    }

    const formattedData = data
        .filter(item => item.worst < 0)  // Filter out items with no drawdown
        .map(item => ({
            id: item.label,
            drawdown: item.worst,  // Drawdown in negative to show fall
            recovery: item.backToEven,  // Recovery is a positive value
        }))
        .sort((a, b) => a.recovery - b.recovery);

    return (
        <ResponsiveBar
            data={formattedData}
            keys={['drawdown', 'recovery']}
            indexBy="id"
            margin={{ top: 10, right: 50, bottom: 50, left: 180 }}
            padding={0.3}
            layout="horizontal"
            defs={[
                // Define gradient for recovery bars (green)
                {
                    id: 'gradientGreen',
                    type: 'linearGradient',
                    colors: [
                        { offset: 0, color: '#97e3d5' },
                        { offset: 100, color: '#63c9ab' }
                    ]
                },
                // Define gradient for drawdown bars (red)
                {
                    id: 'gradientRed',
                    type: 'linearGradient',
                    colors: [
                        { offset: 0, color: '#f47560' },
                        { offset: 100, color: '#e6492d' }
                    ]
                },
                // Define pattern for drawdown bars
                {
                    id: 'checkeredPattern',
                    type: 'patternLines',
                    background: 'inherit',
                    color: '#e6492d',
                    rotation: -45,
                    lineWidth: 4,
                    spacing: 6
                }
            ]}
            fill={[
                { match: { id: 'drawdown' }, id: 'gradientRed' },
                { match: { id: 'drawdown' }, id: 'checkeredPattern' },
                { match: { id: 'recovery' }, id: 'gradientGreen' }
            ]}
            colors={({ id, data }) => {
                // Use gradients as defined in defs
                return id === 'drawdown' ? 'url(#gradientRed)' : 'url(#gradientGreen)';
            }}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: 'Percentage',
                legendPosition: 'middle',
                legendOffset: 32
            }}
            axisLeft={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: -40,
                format: value => `${value}`.length > 20 ? `${value.substring(0, 17)}...` : value,
                tickLabelWidth: 150,
                tickLabelHeight: 20,
                wrap: true
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            label={({ value }) => `${(value * 100).toFixed(1)}%`}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            animate={true}
            motionStiffness={90}
            motionDamping={15}
            legends={[
                {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 0,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                        {
                            on: 'hover',
                            style: {
                                itemOpacity: 1
                            }
                        }
                    ]
                }
            ]}
        />
    );
};

export default CumulativeRecoveryWaterfallChart;
